import { StandardTable } from "@/components/table/StandardTable";
import { Flex, Text } from "@chakra-ui/react";
import { ReactNode, useMemo } from "react";

interface ProductItem {
  idProducto: number;
  nombre: string;
  cantidad: string;
}

interface Props {
  items: ProductItem[];
  rightElement?: ReactNode;
}

export const FertSlotRequestProductsTable = ({ items, rightElement }: Props) => {
  const headers = useMemo(
    () => [
      { label: "Nombre", value: "nombreProducto", align: "inherit" },
      { label: "Cantidad (en toneladas)", value: "cantidad", align: "inherit" },
    ],
    [],
  );

  return (
    <Flex flexDir="column" gap="8px">
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontWeight={700}>Productos solicitados</Text>
        {rightElement}
      </Flex>
      <StandardTable
        items={items}
        headers={headers}
        noSelection
        noActions
        rowId="idProducto"
        fullWidth
        maxHeight="240px"
      />
    </Flex>
  );
};
